<template>
  <div class="common-breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>当前位置：机考模拟系统</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      <el-breadcrumb-item class="examName" v-if="examName !== ''" :title="examName">{{ examName }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="common-toolbar" v-if="isShowToolbar">
      <span class="toolbarBtnGroup">
        <a href="javascript:void(0)" @click="changeFontSize(13)">小</a>
        <a href="javascript:void(0)" @click="changeFontSize(14)">中</a>
        <a href="javascript:void(0)" @click="changeFontSize(15)">大</a>
      </span>
      <router-link class="toolbarBtn back" :to="{name: 'examSystem', query: {siteCourseID, courseID}}">返回首页</router-link>
      <a href="javascript:void(0)" class="toolbarBtn print" @click="handlePrint">打印</a>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      examName: {
        type: String,
        default: ''
      },
      isShowToolbar: {
        type: Boolean,
        default: false
      },
      siteCourseID: {
        type: Number,
        default: null
      },
      courseID: {
        type: Number,
        default: null
      }
    },
    methods:{
      //切换子体大小
      changeFontSize(size) {
        this.$emit('changeFontSize',size)
      },
      //打印
      handlePrint() {
        this.$emit('handlePrint')
      }
    }
  }
</script>
<style lang="scss">
  $bgUrl: '../../assets/images';
  .common-breadcrumb {
    background-color: #c7c9cc;
    height: 40px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-content: center;

    .el-breadcrumb {
      height: 30px;
      line-height: 40px;

      .el-breadcrumb__separator {
        color: #666;
      }
    }
    .examName{
      width:400px;
      white-space:nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .common-toolbar {
    line-height: 40px;

    .toolbarBtn {
      margin: 0 10px;
      font-size: 12px;
      padding:2px 8px;
      color: #606266;
      /*border:1px solid #fdd096;*/
      background-image: url($bgUrl + "/Analysis/hbtnbg.jpg");
    }
    .toolbarBtn.print {
      margin: 0;
    }

    .toolbarBtnGroup {
      a {
        color: #606266;
        font-size: 12px;
        margin: 0 3px;
      }
    }
  }
</style>
